import { Avatar, AvatarProps } from '@mui/material';
import profileimg from 'assets/images/profileimg.png';
import { useAuthenticatedBlobUrl } from 'hooks/useAuthenticatedBlobUrl';
import React from 'react';

type AuthenticatedAvatarProps = Omit<AvatarProps, 'src'> & {
  fallbackSrc?: string;
  fileId?: string | null;
};

export function AuthenticatedAvatar({
  fileId,
  fallbackSrc = profileimg,
  ...avatarProps
}: AuthenticatedAvatarProps) {
  const { url } = useAuthenticatedBlobUrl(fileId ?? null);
  return <Avatar {...avatarProps} src={url ?? fallbackSrc} />;
}
